/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalCommonCustomAttributeDoubleSelectTypeValue interface.
 */
export function instanceOfInternalCommonCustomAttributeDoubleSelectTypeValue(value) {
    return true;
}
export function InternalCommonCustomAttributeDoubleSelectTypeValueFromJSON(json) {
    return InternalCommonCustomAttributeDoubleSelectTypeValueFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDoubleSelectTypeValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mainOption': json['main_option'] == null ? undefined : json['main_option'],
        'subOption': json['sub_option'] == null ? undefined : json['sub_option'],
    };
}
export function InternalCommonCustomAttributeDoubleSelectTypeValueToJSON(json) {
    return InternalCommonCustomAttributeDoubleSelectTypeValueToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeDoubleSelectTypeValueToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'main_option': value['mainOption'],
        'sub_option': value['subOption'],
    };
}
